import React from 'react';
import { Card } from "react-bootstrap";
import styles from '../outlets/SessionHistoryDetailView.module.css';

const SignAndLockCard = ({
  providerName,
  providerCredentials,
  isSigned = false,
  signingAndSubmitting = false,
  onSignAndLock,
  signedAt = null,
  canEditAddendum = false, // For SessionHistoryDetailView addendum functionality
}) => {
  // Get signed date/time (with fallback to current date/time for preview)
  const signedDate = new Date().toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric"
  });

  const signedTime = new Date().toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true
  });

  // Get signed date/time from database only (for display after signing)
  const getSignedDateFromDB = () => {
    if (!signedAt) return null;
    return new Date(signedAt).toLocaleDateString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric"
    });
  };

  const getSignedTimeFromDB = () => {
    if (!signedAt) return null;
    return new Date(signedAt).toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true
    });
  };

  const signedDateFromDB = getSignedDateFromDB();
  const signedTimeFromDB = getSignedTimeFromDB();

  return (
    <Card className={styles.card} style={{
      width: "100%",
      marginBottom: "0"
    }}>
      <h3 className={styles.sectionHeading} style={{ marginBottom: "24px", fontSize: "20px" }}>
        {isSigned && !canEditAddendum ? "Provider Signature" : "Sign & Lock Note"}
      </h3>

      <div className={styles.separator} style={{ width: "40%" }}></div>

      {!isSigned || canEditAddendum ? (
        <>
          {/* Your Name */}
          <div style={{ marginBottom: "20px" }}>
            <label className={styles.label} style={{ marginBottom: "8px", display: "block", textAlign: "left", fontWeight: "500" }}>
              Your Name
            </label>
            <input
              type="text"
              value={providerName || ""}
              readOnly
              className={styles.otherTextInput}
            />
          </div>

          {/* Credentials */}
          <div style={{ marginBottom: "24px" }}>
            <label className={styles.label} style={{ marginBottom: "8px", display: "block", textAlign: "left", fontWeight: "500" }}>
              Credentials
            </label>
            <input
              type="text"
              value={providerCredentials || ""}
              readOnly
              className={styles.otherTextInput}
            />
          </div>

          {/* Preview */}
          <div style={{ marginBottom: "24px" }}>
            <label className={styles.label} style={{ marginBottom: "12px", display: "block", textAlign: "left", fontWeight: "500" }}>
              Preview
            </label>
            <div style={{
              padding: "20px",
              border: "none !important",
              borderRadius: "4px",
              backgroundColor: "#FAFAFA",
              minHeight: "150px",
              textAlign: "left"
            }}>
              {/* Signature Preview */}
              <div style={{
                fontFamily: "'Brush Script MT', 'Brush Script', cursive",
                fontSize: "32px",
                color: "#1a1a1a",
                marginBottom: "16px",
                textAlign: "left",
                fontWeight: "400",
                letterSpacing: "1px"
              }}>
                {providerName || ""}
              </div>
              <div style={{
                fontSize: "14px",
                color: "#666",
                marginBottom: "4px"
              }}>
                Signed by {providerName || ""}, {providerCredentials || ""}
              </div>
              <div style={{
                fontSize: "14px",
                color: "#666"
              }}>
                {signedDate || ""}; {signedTime || ""}
              </div>
            </div>
          </div>

          {/* Attestation */}
          <div style={{ marginBottom: "24px" }}>
            <p style={{
              fontSize: "14px",
              color: "#000",
              lineHeight: "1.6",
              fontWeight: "400",
              margin: "0",
              textAlign: "left"
            }}>
              I attest that this note accurately reflects the services provided during this session.
            </p>
          </div>

          {/* Sign & Lock Button */}
          <button
            style={{
              width: "60%",
              padding: "14px 24px",
              fontSize: "16px",
              fontWeight: "600",
              color: "#fff",
              backgroundColor: signingAndSubmitting ? "#9BB5C9" : "#064260",
              border: "none",
              borderRadius: "6px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
              transition: "all 0.2s ease",
              cursor: signingAndSubmitting ? "not-allowed" : "pointer"
            }}
            onClick={onSignAndLock}
            disabled={signingAndSubmitting}
          >
            {signingAndSubmitting ? "Signing..." : "Sign & Lock"}
            {!signingAndSubmitting && (
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M7.5 15L12.5 10L7.5 5" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            )}
          </button>
        </>
      ) : (
        <div style={{ marginBottom: "24px" }}>
          <div style={{
            padding: "20px",
            border: "none !important",
            borderRadius: "4px",
            backgroundColor: "#ECF8FE",
            minHeight: "150px",
            textAlign: "left"
          }}>
            {/* Signature Preview */}
            <div style={{
              fontFamily: "'Brush Script MT', 'Brush Script', cursive",
              fontSize: "32px",
              color: "#1a1a1a",
              marginBottom: "16px",
              textAlign: "left",
              fontWeight: "400",
              letterSpacing: "1px"
            }}>
              {providerName || ""}
            </div>
            <div style={{
              fontSize: "14px",
              color: "#666",
              marginBottom: "4px"
            }}>
              Signed by {providerName || ""}, {providerCredentials || ""}
            </div>
            {signedDateFromDB && signedTimeFromDB && (
              <div style={{
                fontSize: "14px",
                color: "#666"
              }}>
                {signedDateFromDB}; {signedTimeFromDB}
              </div>
            )}
          </div>
        </div>
      )}
    </Card>
  );
};

export default SignAndLockCard;

